<template>
  <el-main class="main-con el-main">
    <router-view></router-view>
  </el-main>
</template>

<script>
    export default {
        name: "FinancePayment"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/Finance/FinancePayment.vue